import axios from 'axios';
import { call, put, takeEvery } from 'redux-saga/effects';
import { STATION_HISTORY_REQUEST, stationHistorySuccess, stationHistoryFailure } from '../actions/stationQueryAction';
import { API_PATH }  from '../config';
import { authHeader } from '../helper/authHeader';

const STATION_HISTORY_API = `${API_PATH}/station/query`;

const stationHistoryApi = (stationId, params) => {
   return axios.post(`${STATION_HISTORY_API}/${stationId}`, params, 
      {
         headers: {...authHeader()},
         timeout: 10000
      }).then( (response) => response.data);
}

function* stationHistory(action) {
   let fetch = undefined;
   try {
      fetch = yield call(stationHistoryApi, action.stationId, action.params);
      if (fetch) {
         if (fetch.success) {
            yield put(stationHistorySuccess({history: fetch.result, select: fetch.select, range: fetch.range}));
         } else {
            yield put(stationHistoryFailure('系統處理發生問題, 稍後再試 !'));
         }
      } else {
         yield put(stationHistoryFailure('資料錯誤 !'));
      }

   } catch (error) {
      yield put(stationHistoryFailure(`資料錯誤, ${error.message}`));
   }
}

export default function* watchStationHistoryAction() {
   yield takeEvery(STATION_HISTORY_REQUEST, stationHistory);
}